import React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const UserCircleIcon: React.ComponentType<IconPresentationProps> = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        {...props}
    >
        <path
            fill="currentColor"
            d="M12.71875 12.5C12.09375 11.03125 10.6875 10 9 10L7 10C5.34375 10 3.90625 11.03125 3.3125 12.5C2.1875 11.3125 1.5 9.75 1.5 8C1.5 4.40625 4.40625 1.5 8 1.5C11.59375 1.5 14.5 4.40625 14.5 8C14.5 9.75 13.8125 11.3125 12.71875 12.5ZM11.4375 13.5C10.4375 14.125 9.28125 14.5 8 14.5C6.71875 14.5 5.5625 14.125 4.5625 13.5C4.78125 12.375 5.78125 11.5 7 11.5L9 11.5C10.21875 11.5 11.21875 12.375 11.46875 13.5L11.4375 13.5ZM8 16C12.40625 16 16 12.40625 16 8C16 3.59375 12.40625 0 8 0C3.59375 0 0 3.59375 0 8C0 12.40625 3.59375 16 8 16ZM8 7.5C7.3125 7.5 6.75 6.9375 6.75 6.25C6.75 5.5625 7.3125 5 8 5C8.6875 5 9.25 5.5625 9.25 6.25C9.25 6.9375 8.6875 7.5 8 7.5ZM5.25 6.25C5.25 7.78125 6.46875 9 8 9C9.53125 9 10.75 7.78125 10.75 6.25C10.75 4.71875 9.53125 3.5 8 3.5C6.46875 3.5 5.25 4.71875 5.25 6.25Z"
        />
    </svg>
);

export default UserCircleIcon;